import React from "react";
import { useNavigate } from "react-router-dom";
import { highlightText } from "../../utils/utils";
import "./css/polishCulture.scss";

const SectionList = ({ title, sections, basePath }) => {
  const navigate = useNavigate();

  const renderSectionContent = (section) =>
    Object.entries(section).map(([key, value]) => {
      if (!value) return null;

      if (key.startsWith("content") || key.startsWith("paragraph")) {
        return (
          <p
            key={key}
            className={key.startsWith("paragraph") ? "paragraph" : ""}
            dangerouslySetInnerHTML={{ __html: highlightText(value) }}
          />
        );
      }

      if (key.startsWith("img")) {
        return (
          <div key={key} className="section-page__image-container">
            <img src={value} alt={section.title} className="section-page__image" />
            {/* {section.sourceImg && key === "img" && (
              <p className="image-source">
                Picture from this{" "}
                <a href={section.sourceImg} target="_blank" rel="noopener noreferrer">
                  link
                </a>
              </p>
            )} */}
          </div>
        );
      }

      if (key === "important") {
        return (
          <p
            key={key}
            className="important"
            dangerouslySetInnerHTML={{ __html: highlightText(value) }}
          />
        );
      }

      return null;
    });

  return (
    <div>
      <h1>{title}</h1>
      <div className="section-list container">
        {sections.map((section) => (
          <li
            key={section.id}
            className={`polish-culture__container ${section.a || ""} ${section.b || ""} ${section.c || ""}`}
          >
            <h2>{section.title}</h2>
            {renderSectionContent(section)}
            <div className="button">
              <button onClick={() => navigate(`/${basePath}/${section.id}`)}>Continue Reading</button>
            </div>
          </li>
        ))}
      </div>
    </div>
  );
};

export default SectionList;
